import type { PayoutCell, PayoutColumn, PayoutTab } from './lottery-payout';

function buildColumn(
  rows: string[],
  header: string,
  values: PayoutCell[]
): PayoutColumn {
  return {
    header,
    cells: Object.fromEntries(rows.map((row, i) => [row, values[i] ?? '-'])),
  };
}

// Shared row labels

const PACKAGE_ROWS = [
  'Price',
  'Commission',
  'Prize 1',
  'Prize 2',
  'Prize 3',
  'Special / Prize 4',
  'Consolation / Prize 5',
  'Prize 6',
];

const PRIZE_ROWS_5 = ['Prize 1', 'Prize 2', 'Prize 3', 'Prize 4', 'Prize 5'];
const PRIZE_ROWS_3 = ['Prize 1', 'Prize 2', 'Prize 3'];
const PRIZE_ROWS_4X = ['4A', '4B', '4C', '4D', '4E', '4F'];

// Details
const DETAILS_TAB: PayoutTab = {
  id: 'details',
  label: 'Details',
  content: {
    type: 'package',
    rows: PACKAGE_ROWS,
    visibleColumns: 3,
    columns: [
      buildColumn(PACKAGE_ROWS, 'Big', [
        '1.00',
        '0.00%',
        '3,500.00',
        '1,200.00',
        '600.00',
        '250.00',
        '80.00',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, 'Small', [
        '1.00',
        '0.00%',
        '5,000.00',
        '2,400.00',
        '1,200.00',
        '-',
        '-',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, '4A', [
        '1.00',
        '0.00%',
        '8,000.00',
        { main: '8,000.00', sub: '4B' },
        { main: '8,000.00', sub: '4C' },
        { main: '800.00', sub: '4D' },
        { main: '800.00', sub: '4E' },
        { main: '2,666.67', sub: '4F' },
      ]),
      buildColumn(PACKAGE_ROWS, 'A', [
        '1.00',
        '0.00%',
        '840.00',
        { main: '840.00', sub: '3B' },
        { main: '840.00', sub: '3C' },
        { main: '84.00', sub: '3D' },
        { main: '84.00', sub: '3E' },
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, 'ABC', [
        '1.00',
        '0.00%',
        '280.00',
        '280.00',
        '280.00',
        '-',
        '-',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, '5D', [
        '1.00',
        '0.00%',
        '16,500.00',
        '5,500.00',
        '3,300.00',
        '550.00',
        '22.00',
        '5.50',
      ]),
      buildColumn(PACKAGE_ROWS, '6D', [
        '1.00',
        '0.00%',
        '110,000.00',
        '3,300.00',
        '330.00',
        '33.00',
        '4.40',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, '2A', [
        '1.00',
        '0.00%',
        '63.00',
        { main: '63.00', sub: '2B' },
        { main: '63.00', sub: '2C' },
        { main: '6.30', sub: '2D' },
        { main: '6.30', sub: '2E' },
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, '2F', [
        '1.00',
        '0.00%',
        '21.00',
        '21.00',
        '21.00',
        '-',
        '-',
        '-',
      ]),
    ],
  },
};

// iBox
const IBOX_TAB: PayoutTab = {
  id: 'ibox',
  label: 'iBox',
  content: {
    type: 'ibox',
    subTabs: [
      {
        label: 'Big',
        rows: PRIZE_ROWS_5,
        visibleColumns: 2,
        columns: [
          buildColumn(PRIZE_ROWS_5, 'iBox 24', [
            '145.83',
            '50.00',
            '25.00',
            '10.42',
            '3.33',
          ]),
          buildColumn(PRIZE_ROWS_5, 'iBox 12', [
            '291.67',
            '100.00',
            '50.00',
            '20.83',
            '6.67',
          ]),
          buildColumn(PRIZE_ROWS_5, 'iBox 6', [
            '583.33',
            '200.00',
            '100.00',
            '41.67',
            '13.33',
          ]),
          buildColumn(PRIZE_ROWS_5, 'iBox 4', [
            '875.00',
            '300.00',
            '150.00',
            '62.50',
            '20.00',
          ]),
        ],
      },
      {
        label: 'Small',
        rows: PRIZE_ROWS_3,
        visibleColumns: 2,
        columns: [
          buildColumn(PRIZE_ROWS_3, 'iBox 24', ['208.33', '100.00', '50.00']),
          buildColumn(PRIZE_ROWS_3, 'iBox 12', ['416.67', '200.00', '100.00']),
          buildColumn(PRIZE_ROWS_3, 'iBox 6', ['833.33', '400.00', '200.00']),
          buildColumn(PRIZE_ROWS_3, 'iBox 4', ['1,250.00', '600.00', '300.00']),
        ],
      },
      {
        label: 'Prize',
        rows: PRIZE_ROWS_4X,
        visibleColumns: 2,
        columns: [
          buildColumn(PRIZE_ROWS_4X, 'iBox 24', [
            '333.33',
            '333.33',
            '333.33',
            '33.33',
            '33.33',
            '111.11',
          ]),
          buildColumn(PRIZE_ROWS_4X, 'iBox 12', [
            '666.67',
            '666.67',
            '666.67',
            '66.67',
            '66.67',
            '222.22',
          ]),
          buildColumn(PRIZE_ROWS_4X, 'iBox 6', [
            '1,333.33',
            '1,333.33',
            '1,333.33',
            '133.33',
            '133.33',
            '444.44',
          ]),
          buildColumn(PRIZE_ROWS_4X, 'iBox 4', [
            '2,000.00',
            '2,000.00',
            '2,000.00',
            '200.00',
            '200.00',
            '666.67',
          ]),
        ],
      },
    ],
  },
};

// Grand Dragon Package

const GD_PACKAGE_TAB: PayoutTab = {
  id: 'gd-package',
  label: 'Grand Dragon Package',
  content: {
    type: 'package',
    rows: PACKAGE_ROWS,
    visibleColumns: 3,
    columns: [
      buildColumn(PACKAGE_ROWS, 'Big', [
        '1.00',
        '0.00%',
        '2,900.00',
        '1,000.00',
        '500.00',
        '200.00',
        '60.00',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, 'Small', [
        '1.00',
        '0.00%',
        '3,900.00',
        '2,000.00',
        '1,000.00',
        '-',
        '-',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, '4A', [
        '1.00',
        '0.00%',
        '6,800.00',
        { main: '6,800.00', sub: '4B' },
        { main: '6,800.00', sub: '4C' },
        { main: '680.00', sub: '4D' },
        { main: '680.00', sub: '4E' },
        { main: '2,266.67', sub: '4F' },
      ]),
      buildColumn(PACKAGE_ROWS, 'A', [
        '1.00',
        '0.00%',
        '705.00',
        { main: '705.00', sub: '3B' },
        { main: '705.00', sub: '3C' },
        { main: '70.50', sub: '3D' },
        { main: '70.50', sub: '3E' },
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, 'ABC', [
        '1.00',
        '0.00%',
        '235.00',
        '235.00',
        '235.00',
        '-',
        '-',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, '6D', [
        '1.00',
        '0.00%',
        '150,000.00',
        '5,000.00',
        '500.00',
        '50.00',
        '5.00',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, '2A', [
        '1.00',
        '0.00%',
        '90.00',
        { main: '90.00', sub: '2B' },
        { main: '90.00', sub: '2C' },
        { main: '9.00', sub: '2D' },
        { main: '9.00', sub: '2E' },
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, '2F', [
        '1.00',
        '0.00%',
        '30.00',
        '30.00',
        '30.00',
        '-',
        '-',
        '-',
      ]),
    ],
  },
};

// GD iBox

const GD_IBOX_TAB: PayoutTab = {
  id: 'gd-ibox',
  label: 'GD iBox',
  content: {
    type: 'ibox',
    subTabs: [
      {
        label: 'Big',
        rows: PRIZE_ROWS_5,
        visibleColumns: 2,
        columns: [
          buildColumn(PRIZE_ROWS_5, 'iBox 24', [
            '120.83',
            '41.67',
            '20.83',
            '8.33',
            '2.50',
          ]),
          buildColumn(PRIZE_ROWS_5, 'iBox 12', [
            '241.67',
            '83.33',
            '41.67',
            '16.67',
            '5.00',
          ]),
          buildColumn(PRIZE_ROWS_5, 'iBox 6', [
            '483.33',
            '166.67',
            '83.33',
            '33.33',
            '10.00',
          ]),
          buildColumn(PRIZE_ROWS_5, 'iBox 4', [
            '725.00',
            '250.00',
            '125.00',
            '50.00',
            '15.00',
          ]),
        ],
      },
      {
        label: 'Small',
        rows: PRIZE_ROWS_3,
        visibleColumns: 2,
        columns: [
          buildColumn(PRIZE_ROWS_3, 'iBox 24', ['162.50', '83.33', '41.67']),
          buildColumn(PRIZE_ROWS_3, 'iBox 12', ['325.00', '166.67', '83.33']),
          buildColumn(PRIZE_ROWS_3, 'iBox 6', ['650.00', '333.33', '166.67']),
          buildColumn(PRIZE_ROWS_3, 'iBox 4', ['975.00', '500.00', '250.00']),
        ],
      },
      {
        label: 'Prize',
        rows: PRIZE_ROWS_4X,
        visibleColumns: 2,
        columns: [
          buildColumn(PRIZE_ROWS_4X, 'iBox 24', [
            '283.33',
            '283.33',
            '283.33',
            '28.33',
            '28.33',
            '94.44',
          ]),
          buildColumn(PRIZE_ROWS_4X, 'iBox 12', [
            '566.67',
            '566.67',
            '566.67',
            '56.67',
            '56.67',
            '188.89',
          ]),
          buildColumn(PRIZE_ROWS_4X, 'iBox 6', [
            '1,133.33',
            '1,133.33',
            '1,133.33',
            '113.33',
            '113.33',
            '377.78',
          ]),
          buildColumn(PRIZE_ROWS_4X, 'iBox 4', [
            '1,700.00',
            '1,700.00',
            '1,700.00',
            '170.00',
            '170.00',
            '566.67',
          ]),
        ],
      },
    ],
  },
};

// 9 Lotto Package

const LOTTO9_PACKAGE_TAB: PayoutTab = {
  id: '9lotto-package',
  label: '9 Lotto Package',
  content: {
    type: 'package',
    rows: PACKAGE_ROWS,
    visibleColumns: 3,
    columns: [
      buildColumn(PACKAGE_ROWS, 'Big', [
        '1.00',
        '0.00%',
        '3,000.00',
        '1,000.00',
        '500.00',
        '200.00',
        '60.00',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, 'Small', [
        '1.00',
        '0.00%',
        '4,000.00',
        '2,000.00',
        '1,000.00',
        '-',
        '-',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, '4A', [
        '1.00',
        '0.00%',
        '7,000.00',
        { main: '7,000.00', sub: '4B' },
        { main: '7,000.00', sub: '4C' },
        { main: '700.00', sub: '4D' },
        { main: '700.00', sub: '4E' },
        { main: '2,333.33', sub: '4F' },
      ]),
      buildColumn(PACKAGE_ROWS, 'A', [
        '1.00',
        '0.00%',
        '720.00',
        { main: '720.00', sub: '3B' },
        { main: '720.00', sub: '3C' },
        { main: '720.00', sub: '3D' },
        { main: '72.00', sub: '3E' },
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, 'ABC', [
        '1.00',
        '0.00%',
        '240.00',
        '240.00',
        '240.00',
        '90.00',
        '-',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, '2D', [
        '1.00',
        '0.00%',
        '90.00',
        '-',
        '-',
        '-',
        '-',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, '2A', [
        '1.00',
        '0.00%',
        '30.00',
        '30.00',
        '30.00',
        '-',
        '-',
        '-',
      ]),
      buildColumn(PACKAGE_ROWS, '2F', [
        '1.00',
        '0.00%',
        '100,000.00',
        '3,000.00',
        '300.00',
        '30.00',
        '4.00',
        '-',
      ]),
    ],
  },
};

// 9 Lotto iBox

const LOTTO9_IBOX_TAB: PayoutTab = {
  id: '9lotto-ibox',
  label: '9 Lotto iBox',
  content: {
    type: 'ibox',
    subTabs: [
      {
        label: 'Big',
        rows: PRIZE_ROWS_5,
        visibleColumns: 2,
        columns: [
          buildColumn(PRIZE_ROWS_5, 'iBox 24', [
            '125.00',
            '41.67',
            '20.83',
            '8.33',
            '2.50',
          ]),
          buildColumn(PRIZE_ROWS_5, 'iBox 12', [
            '250.00',
            '83.33',
            '41.67',
            '16.67',
            '5.00',
          ]),
          buildColumn(PRIZE_ROWS_5, 'iBox 6', [
            '500.00',
            '166.67',
            '83.33',
            '33.33',
            '10.00',
          ]),
          buildColumn(PRIZE_ROWS_5, 'iBox 4', [
            '750.00',
            '250.00',
            '125.00',
            '50.00',
            '15.00',
          ]),
        ],
      },
      {
        label: 'Small',
        rows: PRIZE_ROWS_3,
        visibleColumns: 2,
        columns: [
          buildColumn(PRIZE_ROWS_3, 'iBox 24', ['166.67', '83.33', '41.67']),
          buildColumn(PRIZE_ROWS_3, 'iBox 12', ['333.33', '166.67', '83.33']),
          buildColumn(PRIZE_ROWS_3, 'iBox 6', ['666.67', '333.33', '166.67']),
          buildColumn(PRIZE_ROWS_3, 'iBox 4', ['333.33', '500.00', '250.00']),
        ],
      },
      {
        label: 'Prize',
        rows: PRIZE_ROWS_4X,
        visibleColumns: 2,
        columns: [
          buildColumn(PRIZE_ROWS_4X, 'iBox 24', [
            '291.67',
            '291.67',
            '291.67',
            '29.17',
            '29.17',
            '97.22',
          ]),
          buildColumn(PRIZE_ROWS_4X, 'iBox 12', [
            '585.33',
            '585.33',
            '585.33',
            '58.33',
            '58.33',
            '194.44',
          ]),
          buildColumn(PRIZE_ROWS_4X, 'iBox 6', [
            '1,166.67',
            '1,166.67',
            '1,166.67',
            '116.67',
            '116.67',
            '388.89',
          ]),
          buildColumn(PRIZE_ROWS_4X, 'iBox 4', [
            '1,750.00',
            '1,750.00',
            '1,750.00',
            '175.00',
            '175.00',
            '583.33',
          ]),
        ],
      },
    ],
  },
};

// Final export

export const MOCK_PAYOUT_TABS: PayoutTab[] = [
  DETAILS_TAB,
  IBOX_TAB,
  GD_PACKAGE_TAB,
  GD_IBOX_TAB,
  LOTTO9_PACKAGE_TAB,
  LOTTO9_IBOX_TAB,
];
